<h1 style="color: #2A6ECF;">CHECK-IN</h1>
<div class = "clock-container">

    @if(!data()){
      <h1>Sem reserva para check-in</h1>
    }
    
    @if(data()?.checkIn){
          <div class="clock">
                
              <tds-icon name="tick" size="200px" style="color: green;"></tds-icon>
              <h1>CHECK-IN REALIZADO!</h1>
                
          </div>

    }
    
    @if(data() && data()?.checkIn == "00:00:00" || data() && !data()?.checkIn){
        
      <div class="clock" [class]="timeStatus()">
            @if (showWarningIcon()) {
              <tds-icon name="warning" size="200px"></tds-icon>
            }
          <h1 style="font-size: 15vmin;">{{formattedTime()}}</h1>
      </div>

      <h1>{{data()?.reservationDate | date:'dd/MM/yyyy' }} <br> {{data()?.tableName}}  (P{{data()?.building}}-{{data()?.region}})</h1> <br><br>

      <div class="clock-buttons">

          <tds-button
            text="Check-In"
            type="button"
            variant="primary"
            size="lg"
            animation="fade"
            tds-aria-label="A button component"
            name="X"
            value="X"
            (click)="executeCheckin(data()!)"
            >
              <tds-icon slot="icon" size="20px" name="timer"></tds-icon>
          </tds-button>
          <tds-button
            text="Cancelar Reserva"
            type="button"
            variant="danger"
            size="lg"
            animation="fade"
            tds-aria-label="A button component"
            name="X"
            value="X"
            (click)="cancelReservation(data()!)"
            >
              <tds-icon slot="icon" size="20px" name="trash"></tds-icon>
          </tds-button>

      </div>

    }
    
    

</div>
